const PICKER_SELECTOR = ".picker-dialog, .picker-dialog-bg";

/**
 * Whether an event target is part of the Google Picker, which mounts on
 * `<body>` outside any dialog that opened it. Dialogs that host a Drive
 * source ignore such clicks and focus moves as "outside" interactions.
 */
export const isGooglePickerTarget = (target: EventTarget | null): boolean =>
  target instanceof Element && target.closest(PICKER_SELECTOR) !== null;
